export const initTooltips = (element) => {
    const tooltipTriggerList = element?.querySelectorAll('[data-bs-toggle="tooltip"]')

    if(tooltipTriggerList) {
        return [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
    }
};
